import { DiffStates } from '@interface/index';

export interface EntityTag {
  entityId?: string;
  descendantEntityId?: string;
  state?: DiffStates;
}

